import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  listUsers,
  createUser,
  setUserPassword,
  updateUserRole,
  type CreateUserInput,
} from '@/lib/api';

/** All app logins, with role, last sign-in, and last activity. */
export function useUsers() {
  return useQuery({
    queryKey: ['app-users'],
    queryFn: listUsers,
    refetchOnMount: 'always',
    staleTime: 0,
  });
}

export function useCreateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateUserInput) => createUser(input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['app-users'] }),
  });
}

export function useSetUserPassword() {
  return useMutation({
    mutationFn: ({ userId, password }: { userId: string; password: string }) =>
      setUserPassword(userId, password),
  });
}

export function useUpdateUserRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, role }: { userId: string; role: string }) =>
      updateUserRole(userId, role),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['app-users'] }),
  });
}
